app.controller("QuestionnairesIndexController", ["$scope", "$stateParams", "QuestionnairesService", "StaticData", "$uibModal", "$state", "ConfirmModal", "toastr", "usSpinnerService",
    function ($scope, $stateParams, QuestionnairesService, StaticData, $uibModal, $state, ConfirmModal, toastr, usSpinnerService) {
        $scope.format = 'dd-MM-yyyy';
        $scope.questionnaires = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;
        $scope.page = $stateParams.page || 1;
        $scope.limit = $stateParams.limit || 25;
        $scope.title = null;
        $scope.query = $stateParams.query;
        $scope.fromDate = $stateParams.fromDate ? new Date(parseInt($stateParams.fromDate)) : undefined;
        $scope.toDate = $stateParams.toDate ? new Date(parseInt($stateParams.toDate)) : undefined;
        $scope.owned = $stateParams.owned === 'true';
        $scope.filterType = $stateParams.type || null;
        $scope.filterTypes = [];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate, function () {});

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levelsMap = _.keyBy(levels, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.statesMap = _.keyBy(states, '_id');
        });

        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasonsMap = _.keyBy(seasons, '_id');
        });

        StaticData.getItemsByKey("questionnaire_filter_types").then(function (types) {
            $scope.filterTypes = [{ name: "ფილტრის ტიპი" }].concat(types);
            $scope.filterTypesMap = _.keyBy(types, '_id');
        });

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        $scope.editQuestionnaires = function (questionnaire) {
            $state.go("admin.questionnaires.create", {
                operationType: 'edit',
                questionnaireId: questionnaire._id
            });
        };

        $scope.resendQuestionnaire = function (questionnaire) {
            $state.go("admin.questionnaires.send", {
                questionnaireId: questionnaire._id,
            });
        };

        $scope.remove = function (questionnaire, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "ყურადღება",
                message: "გსურთ კითხვარის წაშლა ?"
            }).result.then(function () {
                QuestionnairesService.deleteTemplate(questionnaire._id).then(function () {
                    loadPage();
                    toastr.success('', 'კითხვარი წაშლილია');
                });
            });
        };

        $scope.copyQuestionnaire = function (questionnaire) {
            ConfirmModal.show({
                title: "",
                message: "გსურთ კითხვარის კოპირება?"
            }).result.then(function () {

                QuestionnairesService.getTemplateById(questionnaire._id).then(function (result) {
                    $scope.newQuestionnaire = result;
                    delete $scope.newQuestionnaire['_id'];
                    delete $scope.newQuestionnaire['createDate'];
                    for (var i in $scope.newQuestionnaire.questions) {
                        delete $scope.newQuestionnaire.questions[i]['_id'];
                    }

                    QuestionnairesService.addTemplate($scope.newQuestionnaire).then(function () {
                        toastr.success('', 'კითხვარი დაკოპირებულია');
                        loadPage($stateParams.page, $scope.query, $scope.fromDate, $scope.toDate, function () {
                        });
                    }, function (err) {
                        console.log('--QuestionnairesService.create err--', err);
                    });
                }, function (err) {
                    console.log('--err--', err);
                });
            });
        };

        $scope.getStatistics = function (questionnaire, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            QuestionnairesService.exportStatistics(questionnaire._id)
        };

        function loadPage(page, query, fromDate, toDate, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            QuestionnairesService.getTemplateList({
                page: page,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                fromDate: $scope.fromDate ? $scope.fromDate.getTime() : undefined,
                toDate: $scope.toDate ? $scope.toDate.getTime() : undefined,
                type: $scope.filterType
            }).then(function (result) {
                $scope.questionnaires = result.docs;
                $scope.totalItems = result.total;
                $scope.currentPage = result.page;
                usSpinnerService.stop("root");
                cb();
            }, function (err) {
                console.log('--err--', err);
            });
        }

        $scope.create = function () {
            $state.go("admin.questionnaires.create", { 'operationType': 'create' });
        };

        $scope.sendHistory = function (questionnaire) {
            $state.go("admin.questionnaires.history", { 'template': questionnaire._id, 'title': questionnaire.title });
        }

        $scope.versions = function (questionnaire) {
            $state.go("admin.questionnaires.versions", { 'template': questionnaire.parent, 'title': questionnaire.title });
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                fromDate: $scope.fromDate ? $scope.fromDate.getTime() : undefined,
                toDate: $scope.toDate ? $scope.toDate.getTime() : undefined,
                type: $scope.filterType
            });
        };
    }
]);
